import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AuthServerProvider, EventManager } from 'src/app/core';
import { ToastrService } from 'ngx-toastr';
import HelperUtil from 'src/app/shared/util/helper-util';
import { FileUploader } from 'ng2-file-upload';
import { environment } from 'src/environments/environment';
@Injectable({ providedIn: 'root' })
export class UploaderService {
    uploader: FileUploader;
    allowedMimeType = [];
    isErrorUpload: boolean = false;
    broadcast: string = 'no-name';
    errors: any = {};
    constructor(
        private authServerProvider: AuthServerProvider,
        private toastr: ToastrService,
        private eventManager: EventManager
    ) {}
    initUploader(api, broadcast, allowedFileType?, properties?) {
        properties = properties || {};
        const attachedFiles = [];
        const config: any = {
            isHTML5: true,
            url: api,
            authToken: 'Bearer ' + this.authServerProvider.getToken(),
            maxFileSize: properties.fileSize  ?  properties.fileSize : environment.MAX_FILE_SIZE,
            autoUpload: false,
            applyOriginalFileName: properties.applyOriginalFileName,
            fileName: properties.applyOriginalFileName ? properties.fileName : '',
            headers: [{
                name: 'clientApiKey',
                value: 'FMARKET-ANGULAR-KEY2'
            }]
        };
        if (allowedFileType) {
            config.allowedFileType = allowedFileType;
        }
        const uploader = new FileUploader(config);
        // clientApiKey: 'FMARKET-ANGULAR-KEY2',
        uploader.onWhenAddingFileFailed = (item, filter) => {
            let message = 'Error Upload';
            switch (filter.name) {
            //   case 'queueLimit':
            //     message = 'Only uploading max ' + environment.MAX_QUEUE_LIMIT + 'files';
            //     break;
              case 'fileSize':
                // tslint:disable-next-line:max-line-length
                message = 'Hình ảnh vượt quá ' + HelperUtil.formatBytes(properties.fileSize || environment.MAX_FILE_SIZE) + ' cho phép';
                break;
              case 'fileType':
                message = 'Chỉ cho phép các loại sau: ' + (allowedFileType || []).join(', ');
                break;
              default:
                message = 'Đã có lỗi xảy ra. Vui lòng thử lại sau.';
                break;
            }
            this.toastr.error(message);
        };
        uploader.onCompleteItem = (item: any, response: any, status: any, headers: any) => {
            if (this.isErrorUpload) {
                return;
            }
            uploader.clearQueue();
            const res = JSON.parse(response);
            const data = res.data || {};
            const imagePath = data.listFileUploaded[0] ? data.listFileUploaded[0].url : '';
            const file = data.listFileUploaded[0];
            let type = 'file';
            if (file.fileName.includes('.doc') || file.fileName.includes('.docx')) {
                type = 'word';
            } else if (file.fileName.includes('.xls') || file.fileName.includes('.xlxs')) {
                type = 'excel';
            } else if (file.fileName.includes('.pdf')) {
                type = 'pdf';
            } else if (file.fileName.includes('.jpg') || file.fileName.includes('.jpeg') || file.fileName.includes('.png') || file.fileName.includes('.gif') ||file.fileName.includes('.svg') ) {
                type = 'image';
            }
            file.type = type;
            const exist = attachedFiles.some(item => item.fileName === file.fileName);
            if (exist) {
                this.toastr.error('File đã tồn tại.');
                return;
            }
            attachedFiles.push(file);
            this.checkExistUrlImage(broadcast, {
                file: file,
                files: attachedFiles,
                imagePath
            }, 1)
        };
        uploader.onAfterAddingFile = (item: any) => {
            item.withCredentials = false; 
            this.isErrorUpload = false;
            this.parseFileToDataUrl(item.file.rawFile, uploader, {pixelSize: properties.pixelSize, pixelSizeMin: properties.pixelSizeMin, isCustom: properties.isCustom, broadcast: broadcast});
        }
        uploader.onBuildItemForm = (fileItem, form) => {
            this.isErrorUpload = false;
            var image: any = document.getElementById('fileUpload');
            if (properties.applyOriginalFileName) {
                form.append('applyOriginalFileName ', true);
                form.append('fileName', UploaderService.filterFileName(properties.fileName || fileItem.file.name));
            }
            form.delete('file');
            return {fileItem, form}
        };
        
        uploader.onBeforeUploadItem = (item: any) => {
            const split = item.file.name.split('.');
            const extension = split.pop();
            const name = split.join('.') + '_' + Date.now() +  '.' + extension;
            item.file.name = name 
            this.isErrorUpload = false;
            return item;
        };
        uploader.onErrorItem = (item: any, response: any, status: any, headers: any) => {
            this.isErrorUpload = true;
            if (!response) {
                return;
            }
            const error = JSON.parse(response);
            this.toastr.error(error.detail || error.message);
        };
        return uploader;
    }
    parseFileToDataUrl(file, uploader, config?: {pixelSize, pixelSizeMin, isCustom, broadcast}) {
        if (FileReader && file) {
            var fr = new FileReader();
            fr.onload = () => {
                const image: any = document.getElementById('fileUpload');
                image.src = fr.result;
                image.alt = file.name;
                setTimeout(() => {
                    const errorPixelMax = config.pixelSize && image.width > config.pixelSize;
                    const errorPixelMin = config.pixelSizeMin && image.width < config.pixelSizeMin;
                    if (!errorPixelMax && !errorPixelMin && !this.isErrorUpload) {
                        if (uploader && !config.isCustom) {
                            uploader.uploadAll();
                        } else {
                            this.eventManager.broadcast({
                                name: config.broadcast + '-base64',
                            });
                        }
                        
                    } else {
                        this.isErrorUpload = true;
                        if (uploader) {
                            uploader.clearQueue();
                        }
                        let message = 'Kích thước sai quy định';
                        if (config.pixelSize === config.pixelSizeMin && (errorPixelMax || errorPixelMin)) {
                            message = `Kích thước quy định , chiều dài ${config.pixelSize}xauto`;
                        } else if (errorPixelMax) {
                            message = `Kích thước vượt quá quy định , chiều dài tối đa ${config.pixelSize}xauto`;
                        } else if (errorPixelMin) {
                            message = `Kích thước nhỏ hơn quy định , chiều dài tối thiểu ${config.pixelSizeMin}xauto`;
                        }
                        this.toastr.error(message);
                    }
                }, 1000)
            }
            fr.readAsDataURL(file);
        }
    }
    checkExistUrlImage(broadcast, content, time) {
        const fileUrl = content.imagePath || content.file.fileUrl  || content.file.url  || '';
        if (!(fileUrl.includes('png') || fileUrl.includes('jpg') || fileUrl.includes('jpeg'))) {
            this.eventManager.broadcast({
                name: broadcast,
                content
            });
        } else {
            var image = new Image();
            image.src = fileUrl;
            setTimeout(() => {
                if (image.width == 0 && time < 5) {
                    setTimeout(() => {
                        time++;
                        this.checkExistUrlImage(broadcast, content, time);
                    }, 1000)
                } else if (image.width > 0) {
                    this.eventManager.broadcast({
                        name: broadcast,
                        content
                    });
                } 
            }, 200)
            
        }
        if (time === 20) {
            this.eventManager.broadcast({
                name: 'upload-fail',
                content: {}
            });
            this.eventManager.broadcast({
                name: broadcast + '-upload-fail',
                content: {}
            });
        }
    }
    static filterFileName(fileName, isRemoveFileType: boolean = true) {
        fileName = fileName || '';
        if (isRemoveFileType) {
            const split = fileName.split('.');
            fileName = split.length > 1 ? split.slice(0, split.length - 1).join('.') : split[0];    
        }
        let fileNameFilter = ''; 
        for (let i = 0; i< fileName.length; i++) {
          const character = fileName[i];
          if ((character >= '0' && character <= '9') || (character >= 'a' && character <= 'z') || 
          (character >= 'A' && character <= 'Z') || character === '_') {
            fileNameFilter += character;
            if (fileNameFilter[0] === '_') {
              fileNameFilter = fileNameFilter.substring(1);
            } 
          }
        }
        return fileNameFilter;
      }  
}
// List of allowedFileTypes values:

// application
// image
// video
// audio
// pdf
// compress
// doc
// xls
// ppt